import { z, toJSONSchema } from 'zod';
import { ROUTES } from '@constants/routes';
import { McpService } from '../mcp';
import { useServiceRef } from 'hooks/useServiceRef';
import { InputSchema, ToolDescriptor, ToolResponse } from '@mcp-b/webmcp-types';

const supportedRoutes = [ `${ROUTES.products}/:productId`,
  `${ROUTES.search}/:searchTerm`,
  ROUTES.catalog,
  ROUTES.signIn,
  ROUTES.signUp,
  ROUTES.myAccount,
  ROUTES.checkout ] as const;

const schema = z.object({
  page: z.string().describe(`The route to navigate to. Supported routes: ${supportedRoutes.join(', ')}`)
});

export const navigateToPageTool: ToolDescriptor<z.infer<typeof schema>, ToolResponse> = {
  name: 'navigate_to_page',
  description: `Navigate to a page. Schema: ${JSON.stringify(schema.shape)}`,
  inputSchema: toJSONSchema(schema) as InputSchema,
  execute: async ({ page }: z.infer<typeof schema>): Promise<ToolResponse> => {
    const mcpServiceRef = useServiceRef(McpService);
    mcpServiceRef.current.navigateToPage(page);

    return {
      content: [ {
        type: 'text',
        text: `Navigated to ${page}.`,
      } ]
    };
  }
};
